import { useThemeTypeContext } from '@/pages/theme-types/useThemeTypeContext';
import { EmptyTableState, Loading } from '@startupquickstart/frontend';
import { FileText } from 'lucide-react';
import { formatDate } from '@startupquickstart/frontend';

export function ThemeTypeOverviewTab() {
  const { themeType, isLoading } = useThemeTypeContext();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  if (!themeType) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        {/* Left column */}
        <div className="lg:col-span-3 space-y-6">
          <div className="rounded-xl border bg-card shadow-sm">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-medium tracking-tight text-zinc-900">About</h2>
              <p className="text-sm text-muted-foreground">
                Theme type description and tone
              </p>
            </div>
            <div className="p-6 space-y-6">
              {themeType.description ? (
                <div>
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-1.5">
                    Description
                  </div>
                  <p className="text-sm whitespace-pre-wrap">{themeType.description}</p>
                </div>
              ) : null}
              {themeType.tone ? (
                <div>
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-1.5">
                    Tone
                  </div>
                  <p className="text-sm whitespace-pre-wrap">{themeType.tone}</p>
                </div>
              ) : null}
              {!themeType.description && !themeType.tone && (
                <EmptyTableState
                  icon={<FileText className="h-6 w-6" />}
                  title="No description or tone"
                  description="Edit to add a description and tone"
                />
              )}
            </div>
            <div className="border-t px-6 py-4 text-sm text-muted-foreground flex flex-wrap gap-x-6 gap-y-1">
              <span>Created: {formatDate(themeType.createdAt)}</span>
              <span>Updated: {formatDate(themeType.updatedAt)}</span>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="lg:col-span-2 space-y-6">
          <div className="rounded-xl border bg-card shadow-sm">
            <div className="px-6 py-4 border-b">
              <h2 className="text-lg font-medium tracking-tight text-zinc-900">Details</h2>
              <p className="text-sm text-muted-foreground">Theme type information</p>
            </div>
            <div className="p-6">
              <div className="divide-y">
                <div className="py-3 first:pt-0">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    Name
                  </div>
                  <div className="text-sm">{themeType.name}</div>
                </div>
                <div className="py-3">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    Slug
                  </div>
                  <div className="text-sm font-mono">{themeType.slug}</div>
                </div>
                <div className="py-3">
                  <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground mb-0.5">
                    ID
                  </div>
                  <div className="text-sm font-mono text-muted-foreground">{themeType.id}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
